import {
  InfoWindow,
  Marker,
  MarkerProps,
  useGoogleMap
} from '@react-google-maps/api'
import React, { ReactNode, useMemo } from 'react'
import { theme } from 'styled'

import { Maybe, ServiceLineMaterial } from 'generated/graphql'
import MarkerPopup from './MarkerPopup'

export interface AppMarkerProps extends MarkerProps {
  address?: Maybe<string>
  assetId: string
  children?: ReactNode
  isLine?: boolean
  locationId?: number
  open?: boolean
  privateMaterial?: Maybe<ServiceLineMaterial>
  privateMaterialColor?: string
  privateVerifiedDate?: Maybe<string>
  publicMaterial?: Maybe<ServiceLineMaterial>
  publicMaterialColor?: string
  publicVerifiedDate?: Maybe<string>
  setAssetOpen?: (value: string) => void
}

export const ICON_PIN = `
  M12.05 3.99c-3.9 0-7 3.1-7 7 0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3
  1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1
  0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z
`

const AppMarker = (props: AppMarkerProps) => {
  const {
    address,
    assetId,
    isLine,
    locationId,
    open,
    position,
    privateMaterial,
    privateMaterialColor,
    privateVerifiedDate,
    publicMaterial,
    publicMaterialColor,
    publicVerifiedDate,
    setAssetOpen
  } = props

  const map = useGoogleMap()
  const title = address || ''
  const publicName = publicMaterial && publicMaterial.selectionValue
  const privateName = privateMaterial && privateMaterial?.selectionValue

  const onMarkerClick = () => {
    if (map) {
      const currentZoom = map.getZoom()
      if (isLine && currentZoom < 15) {
        map.setZoom(15)
      } else if (!isLine) {
        map.setZoom(currentZoom + 1)
      }
      map.panTo(position)
    }

    setAssetOpen && setAssetOpen(assetId)
  }

  const icon = useMemo<google.maps.Symbol>(
    () => ({
      anchor: new google.maps.Point(12, 20),
      fillColor: theme.colors.primary,
      fillOpacity: 1,
      path: ICON_PIN,
      scale: 3,
      strokeColor: theme.colors.primary,
      strokeOpacity: 0,
      strokeWeight: 0
    }),
    []
  )

  return (
    <>
      <Marker icon={icon} onClick={onMarkerClick} title={title} {...props}>
        {isLine && open && (
          <InfoWindow
            onCloseClick={() => setAssetOpen && setAssetOpen('')}
            options={{ position }}>
            <MarkerPopup
              locationId={locationId}
              privateMaterialColor={privateMaterialColor}
              privateName={privateName}
              privateVerifiedDate={privateVerifiedDate}
              publicMaterialColor={publicMaterialColor}
              publicName={publicName}
              publicVerifiedDate={publicVerifiedDate}
              title={title}
            />
          </InfoWindow>
        )}
      </Marker>
    </>
  )
}

export default AppMarker
